import { TimeFrame, TimeFrameEnum } from "schema"

export const BACKOFFICE_RECENT_TIME_FRAME_OPTIONS = [
  TimeFrameEnum.LastMonth,
  TimeFrameEnum.Last2Weeks,
  TimeFrameEnum.Last1Week,
  TimeFrameEnum.Last3Days,
  TimeFrameEnum.Today,
] satisfies TimeFrame[]
